import { Button } from '@rocco/components/button';
import { BASE_STYLE } from './style';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { cn } from '@rocco/utils/cn';

interface ProfileCarouselButtonProps {
    handlePrev: () => void;
    handleNext: () => void;
}

/**
 * Navigation button component for cycling through team member profiles
 */
export const ProfileCarouselButton = ({
    handlePrev,
    handleNext,
}: ProfileCarouselButtonProps) => {
    return (
        <div className={`flex items-center ${BASE_STYLE.GAP_STANDARD}`}>
            <Button
                onClick={handlePrev}
                shape="default"
                color="transparent"
                aria-label="Previous team member"
                className={cn(BASE_STYLE.CAROUSEL_BUTTON)}
            >
                <ArrowLeft className="h-6 w-6" />
            </Button>

            <Button
                onClick={handleNext}
                shape="default"
                color="transparent"
                aria-label="Next team member"
                className={cn(BASE_STYLE.CAROUSEL_BUTTON)}
            >
                <ArrowRight className="h-6 w-6" />
            </Button>
        </div>
    );
};
